<div class="modal-header">
    <h5 class="modal-title">Shipments</h5>

    <button (click)="close()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <table class="table table-striped">
        <thead>

        <tr>
            <th>Nota</th>
            <th>Web</th>
            <th>Afdeling</th>
            <th>Antal varelinjer</th>
            <th>Pakker</th>
        </tr>

        </thead>

        <tbody>
        <tr *ngFor="let shipment of shipments">
            <td>
                <a (click)="showShipment(shipment)" class="text-primary">
                    {{ shipment.nota_number }}</a>
            </td>
            <td>{{ shipment.order_reference }}</td>
            <td>{{ shipment.branch }}</td>
            <td>{{ shipment.shipment_product_lines.length }}</td>
            <td>
                <span [ngClass]="{ 'text-success': shipment.shipment_packages.length > 0, 'text-danger': shipment.shipment_packages?.length == 0 }">
                <i class="fas fa-check " *ngIf="shipment.shipment_packages.length > 0"
                   ngbTooltip="Price adjustment active"></i>
                <i class="fas fa-ban" *ngIf="shipment.shipment_packages?.length == 0"
                   ngbTooltip="Price adjustment not active"></i>
                </span>
                <span *ngIf="shipment.shipment_packages.length > 0">{{shipment.shipment_packages.length}} pakker</span>
            </td>
        </tr>
        </tbody>
    </table>

</div>

<div class="modal-footer">
    <button (click)="close()" type="button" class="btn  btn-secondary" data-dismiss="modal"><span i18n>Close</span>
    </button>
</div>
